import { FC, useRef } from 'react';
import cn from 'classnames';

import { DataLink } from 'components/Shared/SharedComponents';
import { useButtonBgImageStyles } from 'lib/shared.hook';
import { clearLastInteractedPsychicCookie } from 'src/shared/lib/cookie';

import styles from './styles.module.scss';

import type { StickyMobileCTAProps } from '../config/declarations';
import { useMobileStickyButtonView } from '../lib/stickyButton';

const HeaderMobileCTA: FC<StickyMobileCTAProps> = ({
  ctaButton,
  className,
  isStickyCtaActivated,
  setStickyCtaActivationState,
}) => {
  const ctaRef = useRef<HTMLAnchorElement>(null);

  useMobileStickyButtonView(
    ctaButton,
    setStickyCtaActivationState,
    ctaRef,
  );

  const { link } = ctaButton || {};
  const bgImageStyles = useButtonBgImageStyles(link!);

  if (!link) {
    return null;
  }

  return (
    <DataLink
      ref={ctaRef}
      link={link}
      className={cn(
        { [styles.ctaButton]: !bgImageStyles },
        { [styles.hidden]: !isStickyCtaActivated },
        className,
      )}
      onClick={clearLastInteractedPsychicCookie}
    >
      {link.title}
    </DataLink>
  );
};

export default HeaderMobileCTA;
